import React from 'react'
import styled from 'styled-components'
import { NavLink, useLocation } from 'react-router-dom'
import { PATIENT_NAV_ITEMS } from './navItems'
import { shouldUseMocks } from '../services/mockApi/index'

const Bar = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: ${(p) => p.theme?.layout?.bottomNavHeight || '64px'};
  background: ${(p) => p.theme?.color?.bgRaised || '#fff'};
  border-top: 1px solid ${(p) => p.theme?.color?.border || '#E6E0D6'};
  display: flex;
  z-index: ${(p) => p.theme?.z?.bottomNav || 30};
  @media (min-width: 768px) {
    display: none;
  }
`

const Item = styled(NavLink)`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  text-decoration: none;
  color: ${(p) => p.theme?.color?.inkMuted || '#6B7280'};
  font-size: 11px;
  font-weight: 500;
  &.active {
    color: ${(p) => p.theme?.color?.primary || '#1F3A5F'};
    font-weight: 700;
  }
`

const Icon = styled.span`
  font-size: 20px;
`

export default function PatientBottomNav() {
  const location = useLocation()
  const useMocks = shouldUseMocks()
  const items = PATIENT_NAV_ITEMS.filter((i) => i.mobile && (!i.mockOnly || useMocks))

  const isActive = (to, exact) =>
    exact ? location.pathname === to : location.pathname.startsWith(to)

  return (
    <Bar>
      {items.map((item) => (
        <Item
          key={item.id}
          to={item.to}
          end={item.exact}
          className={isActive(item.to, item.exact) ? 'active' : undefined}
        >
          <Icon>{item.icon}</Icon>
          {item.label}
        </Item>
      ))}
    </Bar>
  )
}
